export const getInitials = (name: string) => {
  if (!name) return "";
  return name
    .split(" ")
    .map((n: string) => n[0])
    .join("");
};

export const getAvatarColor = (name: string) => {
  // Available avatar colors
  const colors = ["#344B52", "#0EA5DE", "#53A87A", "#971B5A", "#C2A34A"];
  if (!name) return "#f5f5f5";
  // Simple hash: sum of char codes
  const hash = name
    .split("")
    .reduce((acc: number, char: string) => acc + char.charCodeAt(0), 0);
  // Pick color deterministically
  return colors[hash % colors.length];
};
